module.exports = __webpack_public_path__ + "87bcaee827bab8fb2d0a58d21bbf6503.png";